import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
// import * as config from "config/config";
// import API_CONSTANTS from "constants/constants";
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import { ErrorObject } from "../../api"
import { CreateWarehouseRequest, UpdateWarehouseRequest, WarehouseModel } from "../../api/warehouse.api"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { RootState } from "../../store"
import { createWarehouse, loadWarehouses, resetSuccess, updateWarehouse } from "../../store/warehouse.store"
// import UsersTable from "components/Users/UsersTable";
import Header from "../Layout/Header"
import AddWarehouseModal from "./AddWarehouseModal"
// import DateRangePickerCustom from "components/Common/DateRangePicker/DateRangePickerCustom";
import WarehousesTable from "./WarehousesTable"
// import { parcelHubLogin } from "config/config";

const Warehouses = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { warehouses, loading, error, success } = useAppSelector((state: RootState) => state.warehouses)
    const [warehouseDetails, setWarehouseDetails] = useState({} as WarehouseModel)
    const [errors, setErrors] = useState({} as Record<string, any>)

    const [show, setShow] = useState(false)

    useEffect(() => {
        dispatch(loadWarehouses())
    }, [])

    const handleShow = () => {
        setErrors({})
        setWarehouseDetails({} as WarehouseModel)
        setShow(true)
    }

    const findFormErrors = (customError?: Record<string, any>) => {
        let newErrors = {} as Record<string, any>
        if (!customError) {
            if (error?.payload && error?.payload?.length !== 0) {
                error?.payload?.forEach((e: ErrorObject) => (newErrors[e?.param?.split(".")[1]] = e.msg))
            } else if (error?.error && error?.error !== "") {
                newErrors["genericError"] = error.error
            }
        } else {
            newErrors[customError?.param] = customError?.msg
        }
        return newErrors
    }

    const handleSubmit = async (warehouseDetails: Record<string, any>) => {
        if (warehouseDetails?.id) {
            await dispatch(updateWarehouse(warehouseDetails as UpdateWarehouseRequest))
        } else {
            if (!warehouseDetails.country || warehouseDetails.country === "") {
                warehouseDetails["country"] = "AE"
            }
            await dispatch(createWarehouse(warehouseDetails as CreateWarehouseRequest))
        }
    }

    useEffect(() => {
        if (warehouses.length === 0) {
            dispatch(loadWarehouses())
        }
    }, [])

    useEffect(() => {
        const returnedErrors = findFormErrors()
        setErrors(returnedErrors)
    }, [error?.error, error?.payload?.length])

    useEffect(() => {
        if (success) {
            dispatch(loadWarehouses())
            setShow(false)
            dispatch(resetSuccess())
        }
    }, [success])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="warehouses-container">
                    <Header
                        title={t("Warehouses")}
                        records={warehouses.length}
                        data={warehouses}
                        name="Users"
                        //buttonId="#warehousesExportButton"
                    >
                        <div className="mx-2">
                            {/*<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate} />*/}
                        </div>
                    </Header>
                    <div className="row justify-content-end mt-3 mx-1">
                        <Button className="col-2" onClick={handleShow}>
                            {t("Add Warehouse")}
                        </Button>
                    </div>
                    <div className="row  d-flex">
                        <WarehousesTable
                            warehouses={warehouses}
                            warehouseDetails={warehouseDetails}
                            setWarehouseDetails={setWarehouseDetails}
                            setShow={setShow}
                        />
                    </div>
                    <AddWarehouseModal
                        show={show}
                        loading={loading}
                        handleClose={() => setShow(false)}
                        handleSubmit={handleSubmit}
                        warehouseDetails={warehouseDetails}
                        setWarehouseDetails={setWarehouseDetails}
                        errors={errors}
                        setErrors={setErrors}
                    />
                </div>
            )}
        </>
    )
}

export default Warehouses
